module.exports = __webpack_public_path__ + "static/media/video_ins_frame.08a62b89.png";